import { Button, Grid, TextField, MenuItem } from "@mui/material";
import { useContext } from "react";
import { usersContext } from '../UsersContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { FilterContainer } from "components";
import { applicationContext } from "helpers/services";

let Filter = () => {
    let { userGroups } = useContext(applicationContext);
    let service = useContext(usersContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item>
                <TextField
                    label="Nome"
                    size="small"
                    variant="standard"
                    value={service.search.name}
                    onChange={(e: any) => service.updateSearch({ ...service.search, name: e.target.value })}
                />
            </Grid>
            <Grid item>
                <TextField
                    label="Email"
                    size="small"
                    variant="standard"
                    value={service.search.email}
                    onChange={(e: any) => service.updateSearch({ ...service.search, email: e.target.value })}
                />
            </Grid>
            <Grid item>
                <TextField
                    select
                    label="Visualizza solo"
                    size="small"
                    variant="standard"
                    value={service.search.showOnly}
                    onChange={(e: any) => service.updateSearch({ ...service.search, showOnly: e.target.value })}
                >
                    <MenuItem value="active">Utenti attivi</MenuItem>
                    <MenuItem value="deleted">Utenti non attivi</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={3}>
                <TextField
                    select
                    label="Gruppi"
                    variant="standard"
                    value={service.search.groups}
                    SelectProps={{ multiple: true }}
                    onChange={(e: any) => service.updateSearch({ ...service.search, groups: e.target.value || [] })}
                >
                    {userGroups
                        .map(group => <MenuItem key={group.key} value={group.key}>{group.value}</MenuItem>)
                    }
                </TextField>
            </Grid>

            <Grid item>
                <Button
                    type="submit"
                    color="secondary"
                    variant="outlined"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;